export default "__VITE_ASSET__z$Zz6xMt__"